import { useEffect } from 'react';

// Sets document.title and the <meta name="description"> tag for the current page, then
// restores the site-wide defaults (from public/index.html) on unmount. This is a plain SPA
// (no react-helmet/SSR in this project), so per-page <head> tags are applied imperatively.
export function usePageSeo(title, description) {
  useEffect(() => {
    const previousTitle = document.title;
    const metaTag = document.querySelector('meta[name="description"]');
    const previousDescription = metaTag ? metaTag.getAttribute('content') : null;

    if (title) document.title = title;
    if (description && metaTag) metaTag.setAttribute('content', description);

    return () => {
      document.title = previousTitle;
      if (metaTag && previousDescription !== null) metaTag.setAttribute('content', previousDescription);
    };
  }, [title, description]);
}
